import React, { Component } from 'react'
import styles from '../../Css/SpyneHome/Home.module.css'

class HomeDashBoard extends Component {

    constructor(props){
        super(props);
        this.state={
            img : [
                'https://storage.googleapis.com/spyne-website/SpyneHome-v2/dash-middle.png', //Middle Image of dashboard
                'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-2.png',
                'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-3.png', 
                'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-4.png',
                'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-5.png',
                'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-6.png',
            ],
            oldScrollDiff: 0
        }
    }

    componentDidMount(){
        if(this.props.zoomInImages){
        this.setState({...this.state,img:[...this.props.zoomInImages]})
        }
        document.addEventListener('scroll', this.calE)
    }
    componentDidUpdate(){
        if(this.props.zoomInImages && this.props.zoomInImages.length >1 && (this.props.zoomInImages[0]!==this.state.img[0])){
        this.setState({...this.state,img:[...this.props.zoomInImages]})
        }
        document.addEventListener('scroll', this.calE)
    }
    componentWillUnmount(){
        document.removeEventListener('scroll', this.calE)
    }

    calE = (e)=>{
        const mainEle = document.getElementById('main-ele');
        let scrolledSoFar = window.scrollY;
        let relativeTopPosition = mainEle.getBoundingClientRect().top + document.documentElement.scrollTop;
        const diff = relativeTopPosition-scrolledSoFar;
        if( (scrolledSoFar < relativeTopPosition) && ((diff >= 200) && (diff)<=400)) this.startMovingCloser(diff);
    }

    // left bottom most to right bottom most
    startMovingCloser = async (diff)=>{
        try {
            //console.log('scroll')
            const stage3Start = 200; 
            const stage3End = 225;
            const stage2Start = 226; 
            const stage2End = 240;
            const sideImage0 = document.getElementById('center-img');
            const sideImage1 = document.getElementById('side-image-1');
            const sideImage2 = document.getElementById('side-image-2');
            const sideImage3 = document.getElementById('side-image-3');
            const sideImage4 = document.getElementById('side-image-4');
            const sideImage5 = document.getElementById('side-image-5');

            let isGoingDown = true;
            // check if going up or down
            if(diff <= this.state.oldScrollDiff){
                isGoingDown = true;
            }else{
                isGoingDown = false;
            }

            await this.setState({...this.state, oldScrollDiff: diff});
            // 3 stages
            if(diff>=stage3Start && diff<=stage3End){

                if(isGoingDown){
                    // sideImage1.classList.add(styles['side_image_1_stage_2_inside_animate']);
                    // sideImage1.classList.remove(styles['side_image_1_stage_2_outside_animate']);
                    // sideImage1.classList.remove(styles['side_image_1_stage_1_inside_animate']);
                    // sideImage1.classList.remove(styles['side_image_1_stage_1_outside_animate']);

                    for(let i=1;i<=3;i++){
                        if(i===3){

                            sideImage0.classList.add(styles[`side_image_0_stage_${i}_inside_animate`]);
                            sideImage0.classList.remove(styles[`side_image_0_stage_${i}_outside_animate`]);

                            sideImage1.classList.add(styles[`side_image_1_stage_${i}_inside_animate`]);
                            sideImage1.classList.remove(styles[`side_image_1_stage_${i}_outside_animate`]);

                            sideImage2.classList.add(styles[`side_image_2_stage_${i}_inside_animate`]);
                            sideImage2.classList.remove(styles[`side_image_2_stage_${i}_outside_animate`]);

                            sideImage3.classList.add(styles[`side_image_3_stage_${i}_inside_animate`]);
                            sideImage3.classList.remove(styles[`side_image_3_stage_${i}_outside_animate`]);

                            sideImage4.classList.add(styles[`side_image_4_stage_${i}_inside_animate`]);
                            sideImage4.classList.remove(styles[`side_image_4_stage_${i}_outside_animate`]);

                            sideImage5.classList.add(styles[`side_image_5_stage_${i}_inside_animate`]);
                            sideImage5.classList.remove(styles[`side_image_5_stage_${i}_outside_animate`]);
                        }else{
                            sideImage1.classList.remove(styles[`side_image_1_stage_${i}_inside_animate`]);
                            sideImage1.classList.remove(styles[`side_image_1_stage_${i}_outside_animate`]);
                            sideImage2.classList.remove(styles[`side_image_2_stage_${i}_inside_animate`]);
                            sideImage2.classList.remove(styles[`side_image_2_stage_${i}_outside_animate`]);
                            sideImage3.classList.remove(styles[`side_image_3_stage_${i}_inside_animate`]);
                            sideImage3.classList.remove(styles[`side_image_3_stage_${i}_outside_animate`]);
                            sideImage5.classList.remove(styles[`side_image_5_stage_${i}_inside_animate`]);
                            sideImage5.classList.remove(styles[`side_image_5_stage_${i}_outside_animate`]);
                            sideImage4.classList.remove(styles[`side_image_4_stage_${i}_inside_animate`]);
                            sideImage4.classList.remove(styles[`side_image_4_stage_${i}_outside_animate`]);
                            sideImage0.classList.remove(styles[`side_image_0_stage_${i}_inside_animate`]);
                            sideImage0.classList.remove(styles[`side_image_0_stage_${i}_outside_animate`]);
                        }
                    }
                }else{
                    // sideImage1.classList.add(styles['side_image_1_stage_2_outside_animate']);
                    // sideImage1.classList.remove(styles['side_image_1_stage_2_inside_animate']);
                    // sideImage1.classList.remove(styles['side_image_1_stage_1_inside_animate']);
                    // sideImage1.classList.remove(styles['side_image_1_stage_1_outside_animate']);
                    for(let i=1;i<=3;i++){
                        if(i===3){
                            sideImage0.classList.remove(styles[`side_image_0_stage_${i}_inside_animate`]);
                            sideImage0.classList.add(styles[`side_image_0_stage_${i}_outside_animate`]);

                            sideImage1.classList.remove(styles[`side_image_1_stage_${i}_inside_animate`]);
                            sideImage1.classList.add(styles[`side_image_1_stage_${i}_outside_animate`]);

                            sideImage2.classList.remove(styles[`side_image_2_stage_${i}_inside_animate`]);
                            sideImage2.classList.add(styles[`side_image_2_stage_${i}_outside_animate`]);

                            sideImage3.classList.remove(styles[`side_image_3_stage_${i}_inside_animate`]);
                            sideImage3.classList.add(styles[`side_image_3_stage_${i}_outside_animate`]);

                            sideImage4.classList.remove(styles[`side_image_4_stage_${i}_inside_animate`]);
                            sideImage4.classList.add(styles[`side_image_4_stage_${i}_outside_animate`]);

                            sideImage5.classList.remove(styles[`side_image_5_stage_${i}_inside_animate`]);
                            sideImage5.classList.add(styles[`side_image_5_stage_${i}_outside_animate`]);
                        }else{
                            sideImage1.classList.remove(styles[`side_image_1_stage_${i}_inside_animate`]);
                            sideImage1.classList.remove(styles[`side_image_1_stage_${i}_outside_animate`]);
                            sideImage2.classList.remove(styles[`side_image_2_stage_${i}_inside_animate`]);
                            sideImage2.classList.remove(styles[`side_image_2_stage_${i}_outside_animate`]);
                            sideImage3.classList.remove(styles[`side_image_3_stage_${i}_inside_animate`]);
                            sideImage3.classList.remove(styles[`side_image_3_stage_${i}_outside_animate`]);
                            sideImage5.classList.remove(styles[`side_image_5_stage_${i}_inside_animate`]);
                            sideImage5.classList.remove(styles[`side_image_5_stage_${i}_outside_animate`]);
                            sideImage4.classList.remove(styles[`side_image_4_stage_${i}_inside_animate`]);
                            sideImage4.classList.remove(styles[`side_image_4_stage_${i}_outside_animate`]);
                            sideImage0.classList.remove(styles[`side_image_0_stage_${i}_inside_animate`]);
                            sideImage0.classList.remove(styles[`side_image_0_stage_${i}_outside_animate`]);
                        }
                    }
                }
                
            }else if(diff>=stage2Start && diff<=stage2End){

                if(isGoingDown){
                    // sideImage1.classList.add(styles['side_image_1_stage_2_inside_animate']);
                    // sideImage1.classList.remove(styles['side_image_1_stage_2_outside_animate']);
                    // sideImage1.classList.remove(styles['side_image_1_stage_1_inside_animate']);
                    // sideImage1.classList.remove(styles['side_image_1_stage_1_outside_animate']);

                    for(let i=1;i<=3;i++){
                        if(i===2){
                            sideImage0.classList.add(styles[`side_image_0_stage_${i}_inside_animate`]);
                            sideImage0.classList.remove(styles[`side_image_0_stage_${i}_outside_animate`]);

                            sideImage1.classList.add(styles[`side_image_1_stage_${i}_inside_animate`]);
                            sideImage1.classList.remove(styles[`side_image_1_stage_${i}_outside_animate`]);

                            sideImage2.classList.add(styles[`side_image_2_stage_${i}_inside_animate`]);
                            sideImage2.classList.remove(styles[`side_image_2_stage_${i}_outside_animate`]);

                            sideImage3.classList.add(styles[`side_image_3_stage_${i}_inside_animate`]);
                            sideImage3.classList.remove(styles[`side_image_3_stage_${i}_outside_animate`]);

                            sideImage4.classList.add(styles[`side_image_4_stage_${i}_inside_animate`]);
                            sideImage4.classList.remove(styles[`side_image_4_stage_${i}_outside_animate`]);

                            sideImage5.classList.add(styles[`side_image_5_stage_${i}_inside_animate`]);
                            sideImage5.classList.remove(styles[`side_image_5_stage_${i}_outside_animate`]);
                        }else{
                            sideImage1.classList.remove(styles[`side_image_1_stage_${i}_inside_animate`]);
                            sideImage1.classList.remove(styles[`side_image_1_stage_${i}_outside_animate`]);
                            sideImage2.classList.remove(styles[`side_image_2_stage_${i}_inside_animate`]);
                            sideImage2.classList.remove(styles[`side_image_2_stage_${i}_outside_animate`]);
                            sideImage3.classList.remove(styles[`side_image_3_stage_${i}_inside_animate`]);
                            sideImage3.classList.remove(styles[`side_image_3_stage_${i}_outside_animate`]);
                            sideImage5.classList.remove(styles[`side_image_3_stage_${i}_inside_animate`]);
                            sideImage5.classList.remove(styles[`side_image_3_stage_${i}_outside_animate`]);
                            sideImage4.classList.remove(styles[`side_image_4_stage_${i}_inside_animate`]);
                            sideImage4.classList.remove(styles[`side_image_4_stage_${i}_outside_animate`]);
                            sideImage0.classList.remove(styles[`side_image_0_stage_${i}_inside_animate`]);
                            sideImage0.classList.remove(styles[`side_image_0_stage_${i}_outside_animate`]);
                        }
                    }
                }else{
                    // sideImage1.classList.add(styles['side_image_1_stage_2_outside_animate']);
                    // sideImage1.classList.remove(styles['side_image_1_stage_2_inside_animate']);
                    // sideImage1.classList.remove(styles['side_image_1_stage_1_inside_animate']);
                    // sideImage1.classList.remove(styles['side_image_1_stage_1_outside_animate']);
                    for(let i=1;i<=3;i++){
                        if(i===2){
                            sideImage0.classList.remove(styles[`side_image_0_stage_${i}_inside_animate`]);
                            sideImage0.classList.add(styles[`side_image_0_stage_${i}_outside_animate`]);

                            sideImage1.classList.remove(styles[`side_image_1_stage_${i}_inside_animate`]);
                            sideImage1.classList.add(styles[`side_image_1_stage_${i}_outside_animate`]);

                            sideImage2.classList.remove(styles[`side_image_2_stage_${i}_inside_animate`]);
                            sideImage2.classList.add(styles[`side_image_2_stage_${i}_outside_animate`]);

                            sideImage3.classList.remove(styles[`side_image_3_stage_${i}_inside_animate`]);
                            sideImage3.classList.add(styles[`side_image_3_stage_${i}_outside_animate`]);

                            sideImage4.classList.remove(styles[`side_image_4_stage_${i}_inside_animate`]);
                            sideImage4.classList.add(styles[`side_image_4_stage_${i}_outside_animate`]);

                            sideImage5.classList.remove(styles[`side_image_5_stage_${i}_inside_animate`]);
                            sideImage5.classList.add(styles[`side_image_5_stage_${i}_outside_animate`]);
                        }else{
                            sideImage1.classList.remove(styles[`side_image_1_stage_${i}_inside_animate`]);
                            sideImage1.classList.remove(styles[`side_image_1_stage_${i}_outside_animate`]);
                            sideImage2.classList.remove(styles[`side_image_2_stage_${i}_inside_animate`]);
                            sideImage2.classList.remove(styles[`side_image_2_stage_${i}_outside_animate`]);
                            sideImage3.classList.remove(styles[`side_image_3_stage_${i}_inside_animate`]);
                            sideImage3.classList.remove(styles[`side_image_3_stage_${i}_outside_animate`]);
                            sideImage5.classList.remove(styles[`side_image_5_stage_${i}_inside_animate`]);
                            sideImage5.classList.remove(styles[`side_image_5_stage_${i}_outside_animate`]);
                            sideImage4.classList.remove(styles[`side_image_4_stage_${i}_inside_animate`]);
                            sideImage4.classList.remove(styles[`side_image_4_stage_${i}_outside_animate`]);
                            sideImage0.classList.remove(styles[`side_image_0_stage_${i}_inside_animate`]);
                            sideImage0.classList.remove(styles[`side_image_0_stage_${i}_outside_animate`]);
                        }
                    }
                }
            }else{
                
                if(isGoingDown){
                    // sideImage1.classList.add(styles['side_image_1_stage_1_inside_animate']);
                    // sideImage1.classList.remove(styles['side_image_1_stage_1_outside_animate']);

                    for(let i=1;i<=3;i++){
                        if(i===1){

                            sideImage0.classList.add(styles[`side_image_0_stage_${i}_inside_animate`]);
                            sideImage0.classList.remove(styles[`side_image_0_stage_${i}_outside_animate`]);

                            sideImage1.classList.add(styles[`side_image_1_stage_${i}_inside_animate`]);
                            sideImage1.classList.remove(styles[`side_image_1_stage_${i}_outside_animate`]);

                            sideImage2.classList.add(styles[`side_image_2_stage_${i}_inside_animate`]);
                            sideImage2.classList.remove(styles[`side_image_2_stage_${i}_outside_animate`]);

                            sideImage3.classList.add(styles[`side_image_3_stage_${i}_inside_animate`]);
                            sideImage3.classList.remove(styles[`side_image_3_stage_${i}_outside_animate`]);

                            sideImage4.classList.add(styles[`side_image_4_stage_${i}_inside_animate`]);
                            sideImage4.classList.remove(styles[`side_image_4_stage_${i}_outside_animate`]);

                            sideImage5.classList.add(styles[`side_image_5_stage_${i}_inside_animate`]);
                            sideImage5.classList.remove(styles[`side_image_5_stage_${i}_outside_animate`]);
                        }else{
                            sideImage1.classList.remove(styles[`side_image_1_stage_${i}_inside_animate`]);
                            sideImage1.classList.remove(styles[`side_image_1_stage_${i}_outside_animate`]);
                            sideImage2.classList.remove(styles[`side_image_2_stage_${i}_inside_animate`]);
                            sideImage2.classList.remove(styles[`side_image_2_stage_${i}_outside_animate`]);
                            sideImage3.classList.remove(styles[`side_image_3_stage_${i}_inside_animate`]);
                            sideImage3.classList.remove(styles[`side_image_3_stage_${i}_outside_animate`]);
                            sideImage5.classList.remove(styles[`side_image_5_stage_${i}_inside_animate`]);
                            sideImage5.classList.remove(styles[`side_image_5_stage_${i}_outside_animate`]);
                            sideImage4.classList.remove(styles[`side_image_4_stage_${i}_inside_animate`]);
                            sideImage4.classList.remove(styles[`side_image_4_stage_${i}_outside_animate`]);
                            sideImage0.classList.remove(styles[`side_image_0_stage_${i}_inside_animate`]);
                            sideImage0.classList.remove(styles[`side_image_0_stage_${i}_outside_animate`]);
                        }
                    }
                }else{
                    // sideImage1.classList.add(styles['side_image_1_stage_1_outside_animate']);
                    // sideImage1.classList.remove(styles['side_image_1_stage_1_inside_animate']);
                    // sideImage1.classList.remove(styles['side_image_1_stage_2_inside_animate']);
                    // sideImage1.classList.remove(styles['side_image_1_stage_2_outside_animate']);
                    for(let i=1;i<=3;i++){
                        if(i===1){
                            sideImage0.classList.remove(styles[`side_image_0_stage_${i}_inside_animate`]);
                            sideImage0.classList.add(styles[`side_image_0_stage_${i}_outside_animate`]);

                            sideImage1.classList.remove(styles[`side_image_1_stage_${i}_inside_animate`]);
                            sideImage1.classList.add(styles[`side_image_1_stage_${i}_outside_animate`]);

                            sideImage2.classList.remove(styles[`side_image_2_stage_${i}_inside_animate`]);
                            sideImage2.classList.add(styles[`side_image_2_stage_${i}_outside_animate`]);

                            sideImage3.classList.remove(styles[`side_image_3_stage_${i}_inside_animate`]);
                            sideImage3.classList.add(styles[`side_image_3_stage_${i}_outside_animate`]);

                            sideImage4.classList.remove(styles[`side_image_4_stage_${i}_inside_animate`]);
                            sideImage4.classList.add(styles[`side_image_4_stage_${i}_outside_animate`]);

                            sideImage5.classList.remove(styles[`side_image_5_stage_${i}_inside_animate`]);
                            sideImage5.classList.add(styles[`side_image_5_stage_${i}_outside_animate`]);
                        }else{
                            sideImage1.classList.remove(styles[`side_image_1_stage_${i}_inside_animate`]);
                            sideImage1.classList.remove(styles[`side_image_1_stage_${i}_outside_animate`]);
                            sideImage2.classList.remove(styles[`side_image_2_stage_${i}_inside_animate`]);
                            sideImage2.classList.remove(styles[`side_image_2_stage_${i}_outside_animate`]);
                            sideImage3.classList.remove(styles[`side_image_3_stage_${i}_inside_animate`]);
                            sideImage3.classList.remove(styles[`side_image_3_stage_${i}_outside_animate`]);
                            sideImage5.classList.remove(styles[`side_image_5_stage_${i}_inside_animate`]);
                            sideImage5.classList.remove(styles[`side_image_5_stage_${i}_outside_animate`]);
                            sideImage4.classList.remove(styles[`side_image_4_stage_${i}_inside_animate`]);
                            sideImage4.classList.remove(styles[`side_image_4_stage_${i}_outside_animate`]);
                            sideImage0.classList.remove(styles[`side_image_0_stage_${i}_inside_animate`]);
                            sideImage0.classList.remove(styles[`side_image_0_stage_${i}_outside_animate`]);
                        }
                    }
                }
            }
            // const {left,top} =  sideImage1.getBoundingClientRect();
            // const {width, height} =  mainEle.getBoundingClientRect();
            // const center_img_left = centerImg.getBoundingClientRect().left;
            // const center_img_top = centerImg.getBoundingClientRect().top;

            //sideImage1.style.transform = `translate(-${(((center_img_left-left)/width))+10}%,${(((center_img_top-top)/height))-10}%)`;

        } catch (error) {
            //console.log(error)
        }
    }


    render() {
        return (
            <>
                <div className={styles['spike-container']} id="main-ele">
                    <span className={[styles['spike-container-img']].join(' ')} id="center-img">
                        <img src={this.state.img[0]} alt="" />
                    </span>
                    <span className={[styles['spike-container-img-1']].join(' ')} id="side-image-1">
                        <img src={this.state.img[1]} alt="" />
                    </span>
                    <span className={[styles['spike-container-img-2']].join(' ')} id="side-image-2">
                        <img src={this.state.img[2]} alt="" />
                    </span>
                    <span className={[styles['spike-container-img-3']].join(' ')} id="side-image-3">
                        <img src={this.state.img[3]} alt="" />
                    </span>
                    <span className={[styles['spike-container-img-4']].join(' ')} id="side-image-4">
                        <img src={this.state.img[4]} alt="" />
                    </span>
                    <span className={[styles['spike-container-img-5']].join(' ')} id="side-image-5">
                        <img src={this.state.img[5]} alt="" />
                    </span>
                </div>
            </>
        )
    }
}

export default HomeDashBoard
